/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ amount: NonNullable<unknown>, count: NonNullable<unknown> }} Admin_Discount_Code_Form_Discount_For_The_First_MonthsInputs */

const en_admin_discount_code_form_discount_for_the_first_months = /** @type {(inputs: Admin_Discount_Code_Form_Discount_For_The_First_MonthsInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("en", i?.count, {});
	if (countPlural == "one") return /** @type {LocalizedString} */ (`${i?.amount} off the first month`);
	if (countPlural == "other") return /** @type {LocalizedString} */ (`${i?.amount} off the first ${i?.count} months`);
	return /** @type {LocalizedString} */ ("admin.discount_code_form.discount_for_the_first_months");
};

const de_admin_discount_code_form_discount_for_the_first_months = /** @type {(inputs: Admin_Discount_Code_Form_Discount_For_The_First_MonthsInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("de", i?.count, {});
	if (countPlural == "one") return /** @type {LocalizedString} */ (`${i?.amount} Rabatt im ersten Monat`);
	if (countPlural == "other") return /** @type {LocalizedString} */ (`${i?.amount} Rabatt in den ersten ${i?.count} Monaten`);
	return /** @type {LocalizedString} */ ("admin.discount_code_form.discount_for_the_first_months");
};

const es_admin_discount_code_form_discount_for_the_first_months = /** @type {(inputs: Admin_Discount_Code_Form_Discount_For_The_First_MonthsInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("es", i?.count, {});
	if (countPlural == "one") return /** @type {LocalizedString} */ (`${i?.amount} de descuento el primer mes`);
	if (countPlural == "other") return /** @type {LocalizedString} */ (`${i?.amount} de descuento en los primeros ${i?.count} meses`);
	return /** @type {LocalizedString} */ ("admin.discount_code_form.discount_for_the_first_months");
};

/** @type {(inputs: Admin_Discount_Code_Form_Discount_For_The_First_MonthsInputs) => LocalizedString} */
const fr_admin_discount_code_form_discount_for_the_first_months = en_admin_discount_code_form_discount_for_the_first_months;

/** @type {(inputs: Admin_Discount_Code_Form_Discount_For_The_First_MonthsInputs) => LocalizedString} */
const it_admin_discount_code_form_discount_for_the_first_months = en_admin_discount_code_form_discount_for_the_first_months;

/** @type {(inputs: Admin_Discount_Code_Form_Discount_For_The_First_MonthsInputs) => LocalizedString} */
const pt_br2_admin_discount_code_form_discount_for_the_first_months = en_admin_discount_code_form_discount_for_the_first_months;

/** @type {(inputs: Admin_Discount_Code_Form_Discount_For_The_First_MonthsInputs) => LocalizedString} */
const pl_admin_discount_code_form_discount_for_the_first_months = en_admin_discount_code_form_discount_for_the_first_months;

/** @type {(inputs: Admin_Discount_Code_Form_Discount_For_The_First_MonthsInputs) => LocalizedString} */
const hu_admin_discount_code_form_discount_for_the_first_months = en_admin_discount_code_form_discount_for_the_first_months;

/** @type {(inputs: Admin_Discount_Code_Form_Discount_For_The_First_MonthsInputs) => LocalizedString} */
const ro_admin_discount_code_form_discount_for_the_first_months = en_admin_discount_code_form_discount_for_the_first_months;

/**
* | countPlural | output |
* | --- | --- |
* | "one" | "{amount} off the first month" |
* | "other" | "{amount} off the first {count} months" |
*
* @param {Admin_Discount_Code_Form_Discount_For_The_First_MonthsInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_discount_code_form_discount_for_the_first_months = /** @type {((inputs: Admin_Discount_Code_Form_Discount_For_The_First_MonthsInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Discount_Code_Form_Discount_For_The_First_MonthsInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_discount_code_form_discount_for_the_first_months(inputs)
	if (locale === "de") return de_admin_discount_code_form_discount_for_the_first_months(inputs)
	if (locale === "es") return es_admin_discount_code_form_discount_for_the_first_months(inputs)
	if (locale === "fr") return fr_admin_discount_code_form_discount_for_the_first_months(inputs)
	if (locale === "it") return it_admin_discount_code_form_discount_for_the_first_months(inputs)
	if (locale === "pt-BR") return pt_br2_admin_discount_code_form_discount_for_the_first_months(inputs)
	if (locale === "pl") return pl_admin_discount_code_form_discount_for_the_first_months(inputs)
	if (locale === "hu") return hu_admin_discount_code_form_discount_for_the_first_months(inputs)
	return ro_admin_discount_code_form_discount_for_the_first_months(inputs)
});
export { admin_discount_code_form_discount_for_the_first_months as "admin.discount_code_form.discount_for_the_first_months" }